import { useContext } from 'react';
import { useIntl } from 'react-intl';

import { AmexContext } from '@/components/amex/AmexContextProvider';
import { useAnalytics } from '@/hooks/analytics';
import { useComponentDidMount } from '@/hooks/utils/useComponentDidMount';

import messages from './messages';
import { OfferText, TrialLink, Wrapper } from './styles';

const Welcome = () => {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();
	const { isGlobalOffer } = useContext(AmexContext);

	useComponentDidMount(() => {
		logEvent({
			eventName: 'Welcome : Landed',
			eventProps: { is_global: isGlobalOffer },
		});
	});

	const trialUrl = '/signup-flow';

	return (
		<Wrapper>
			<OfferText>{formatMessage(messages.offerExpired)}</OfferText>
			<TrialLink href={trialUrl}>{formatMessage(messages.tryCalmFree)}</TrialLink>
		</Wrapper>
	);
};

export default Welcome;
